module.exports = __webpack_public_path__ + "static/biennale-bold-74d6c1ad550ef13c1f4dce5e70269545.otf";